// Copyright (c) 2016 Deere & Company

import PipDetails, {getDefaultState as getPipDetailsDefaultState} from '@deere/cps-it.warranty-model-factory/lib/pip-details';
import actions from '../../action-list';
import {getDefaultState} from '../state';

const resetPipDetails = () => getPipDetailsDefaultState();

const updatePipDetails = (state, action) =>
    PipDetails.update(state, {
        $set: action.data
    });

export default (state = getDefaultState().pipDetails, action) => {

    const actionTypes = {
        [actions.RESET_CLAIM_PIP]: resetPipDetails,
        [actions.RESET_CLAIM_PIP_PIP_DETAILS]: resetPipDetails,
        [actions.UPDATE_CLAIM_PIP_PIP_DETAILS]: updatePipDetails
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/claim/pip/reducers/pip-details.js